import React from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { get, canUseDOM, getDictionaryItem } from '../../utils';
import { commonStyles, ltrStyles, rtlStyles, parsedHtml, scrollLazyLoad, checkIE } from '../09_RichText/RichText';
import { tealiumCheckRightTextClick, tealiumMergeClickData } from '../../utils/tealium';
const MainText = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const richTextBody = get(fields, 'data.item.body.jss');
  const dictionary = get(fields, 'data.dictionary');
  const readMoreLabel = getDictionaryItem(dictionary, 'read more');
  const enableShowMoreButton = get(fields, 'data.item.enableShowMoreButton.jss.value');
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const [output, setOutput] = React.useState('');
  const richtextRef = React.useRef();
  const [textHidden, setTextHidden] = React.useState(enableShowMoreButton);
  const richTextAnalytics = get(fields, 'data.richTextAnalytics');
  React.useEffect(() => {
    if (richTextBody) {
      //setOutput(parsedHtml(richTextBody.value as any));
      const isIE = checkIE();
      if (canUseDOM) {
        const obj = parsedHtml(richTextBody.value, isIE);
        setOutput(obj.output);
        if (obj.images && !isIE) {
          setTimeout(() => {
            scrollLazyLoad();
            window.addEventListener('scroll', scrollLazyLoad);
          }, 1);
        }
      }
    }
    if (richtextRef.current) {
      richtextRef.current.classList.remove('height-fix');
    }
  }, [richTextBody, output]);
  if (!fields) {
    console.warn('MainText component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[MainText component is empty: please provide datasource]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-8"
  }, pageEditing && /*#__PURE__*/React.createElement("h2", null, "Edit Main Text:"), /*#__PURE__*/React.createElement(StyledWrapper, {
    className: "rich-text",
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: textHidden ? 'rich-text--hidden' : ''
  }, pageEditing ? /*#__PURE__*/React.createElement(RichText, {
    tag: "div",
    className: "rich-text__inner",
    field: richTextBody
  }) : /*#__PURE__*/React.createElement("div", {
    ref: richtextRef,
    className: "rich-text__inner height-fix",
    dangerouslySetInnerHTML: {
      __html: output
    },
    onClick: e => tealiumCheckRightTextClick(e, tealiumMergeClickData(richTextAnalytics, params))
  })), textHidden && /*#__PURE__*/React.createElement("div", {
    className: "rich-text__show-bar"
  }, /*#__PURE__*/React.createElement("span", {
    onClick: () => {
      setTextHidden(false);
    }
  }, readMoreLabel)))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  })));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    className
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className}`,
    "data-cy": "rich-text"
  }, children);
};
export default MainText;